



















import router from "../router";
import ripple from "./ripple.vue";
import userIcon from "./userIcon.vue";
import gbutton from "./button.vue";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import {frontendClient} from "../lib/client";

@Component({
    components: {
        ripple,
        userIcon,
        gbutton
    }
})
export default class popupDisplay extends Vue {
    @Prop({}) visible:boolean;
    @Prop({}) fillHorizontal:boolean;
    @Prop({}) relative:boolean; 
    @Prop({}) fixed:boolean; 
    @Prop({}) coords:{
        x: number,
        y: number
    }


    useCoords = this.coords;

    userDetails = frontendClient.userData;

    mounted(){

        this.isWithinBounds()

    }

    isWithinBounds(){
        let elem = (this.$refs.container as HTMLElement);
        let box = elem.getBoundingClientRect();

        let rightEdge = box.left + elem.offsetWidth;
        let bottomEdge = box.top + elem.offsetHeight;

        if(rightEdge > window.outerWidth){
            this.useCoords.x -= elem.offsetWidth; 
        }
        if(bottomEdge > window.outerHeight){
            this.useCoords.y -= elem.offsetHeight; 
        }
    }

    async logout(){
        frontendClient.logOut().then(() => {
            location.reload();
        }).catch(() => {
            frontendClient.giveError("ERROR LOGGING OUT");
        });
    }
    redirect(route,parameters?){
        if(parameters){
            this.$router.replace({ name: route, params: parameters});
        }else{
            this.$router.push({ name: route, params: parameters});
        }
    };
}

